import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/useTicketQuery.ts
var r = (r) => t({
	queryKey: e.ticket(r),
	queryFn: () => n.getTicket(r),
	enabled: !!r
});
//#endregion
export { r as useTicketQuery };
